module.exports = __webpack_public_path__ + "img/oem6.c689daa9.png";